import moment from 'moment';
export default {
	getSearchDates_({ searchParams: { strDt, endDt } }) {
		return [moment(strDt).format('YYYY-MM-DD'), moment(endDt).format('YYYY-MM-DD')];
	},
	getColumns_(state, getters, rootState, rootGetters) {
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000956'), //품번
				prop: 'partNo',
				minWidth: '150px',
				sortable: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001821'), //PPRNO
				prop: 'pprNo',
				minWidth: '150px',
				sortable: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001826'), //발생일
				prop: 'occuDd',
				minWidth: '120px',
				sortable: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001464'), //발생장소
				prop: 'occuPlCd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001464'), //발생장소
				prop: 'occuPlNm',
				minWidth: '150px',
				sortable: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC000074'), //불량수량
				prop: 'badQty',
				minWidth: '100px',
				sortable: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001413'), //제기일
				prop: 'pprsDd',
				minWidth: '120px',
				sortable: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001094'), //진행상태
				prop: 'pgsStCd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001094'), //진행상태
				prop: 'pgsStNm',
				minWidth: '100px',
				sortable: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001822'), //대책요구일
				prop: 'rplRqDd',
				minWidth: '120px',
				sortable: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001749'), //대책상태
				prop: 'mdvStNm',
				minWidth: '100px',
				sortable: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001302'), //업체
				prop: 'cofCd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001302'), //업체
				prop: 'cofNm',
				minWidth: '150px',
				sortable: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001465'), //격리수량
				minWidth: '150px',
				sortable: false,
				children: [
					{
						label: rootGetters['commonStore/getMessage_']('MWPP000055'), //부품
						prop: 'sprtQty',
						minWidth: '100px',
						sortable: true
					},
					{
						label: rootGetters['commonStore/getMessage_']('QWCC001466'), //검사수량
						prop: 'ckuQty',
						minWidth: '100px',
						sortable: true
					}
				]
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001467'), //불량유형
				minWidth: '150px',
				sortable: false,
				children: [
					{
						label: rootGetters['commonStore/getMessage_']('QWCC001823'), //유형1
						prop: 'badTypeLgrpCd',
						minWidth: '1px'
					},
					{
						label: rootGetters['commonStore/getMessage_']('QWCC001823'), //유형1
						prop: 'badTypeLgrpNm',
						minWidth: '150px',
						sortable: true
					},
					{
						label: rootGetters['commonStore/getMessage_']('QWCC001824'), //유형2
						prop: 'badTypeMgrpCd',
						minWidth: '1px'
					},
					{
						label: rootGetters['commonStore/getMessage_']('QWCC001824'), //유형2
						prop: 'badTypeMgrpNm',
						minWidth: '150px',
						sortable: true
					},
					{
						label: rootGetters['commonStore/getMessage_']('QWCC001825'), //유형3
						prop: 'badTypeSgrpCd',
						minWidth: '1px'
					},
					{
						label: rootGetters['commonStore/getMessage_']('QWCC001825'), //유형3
						prop: 'badTypeSgrpNm',
						minWidth: '150px',
						sortable: true
					}
				]
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001382'), //작성자
				prop: 'affrDspoNm',
				minWidth: '100px',
				sortable: true
			}
		];
	}
};
